/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react';
import {
  Menu,
  Dropdown,
  Avatar,
  Badge,
  Row,
  Col,
  Typography,
  Button,
  Form,
  Modal,
  Input,
  Select,
  message,
} from 'antd';
import { DownOutlined } from '@ant-design/icons';
import styles from './index.module.scss';
import Logo from '../../components/Logo';

import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { UserOutlined } from '@ant-design/icons';
import DrawerMenu from '../DrawerMenu';
import Icon from '@mdi/react';
import { mdiCart } from '@mdi/js';
import { useLiff } from 'react-liff';
import SubNavbarSCGFamily from './scgFamilySubNavbar';
import { isEmpty } from 'lodash';
import { getStates } from '../../services/api';
import axios from 'axios';

const { Paragraph } = Typography;

const noBannerPages = [
  '/services',
  'apply-job',
  'profile/my-profile',
  'profile/my-address',
  'profile/my-bank-account',
  'profile/service-orders',
  'profile/scg-family',
  'technician',
];

export type TopNavbarProps = {
  src?: string;
  width?: number;
  height?: number;
  logoPath?: string;
  showTechnicianBar?: boolean;
};

const TopNavbar: React.FC<TopNavbarProps> = (props) => {
  const user = useSelector((state: any) => state.user);
  const orderCount = useSelector((state: any) => state.orderCount);
  const currentAddress = useSelector((state: any) => state.currentAddress);
  const location = useLocation();
  const currentPath = useSelector(() => location?.pathname);
  const isNoBannerPage = useSelector(() => {
    return noBannerPages.find((path) => currentPath.includes(path))
      ? true
      : false;
  });

  const { logoPath, showTechnicianBar = true } = props;

  const navigate = useNavigate();

  const [currentUser, setCurrentUser] = useState<any>({});
  const [currentAddresses, setCurrentAddresses] = useState<any>('');
  const [showBlock, setShowBlock] = useState<any>(true);
  const [isSCGFamilyConnected, setIsSCGFamilyConnected] = useState<any>(false);
  const [showModelMissingData, setShowModelMissingData] =
    useState<boolean>(false);
  const [showMaintainState, setShowMaintainState] = useState<boolean>(false);
  const [showMaintainPosition, setShowMaintainPosition] =
    useState<boolean>(false);
  const [formUpdateUserInfo] = Form.useForm();
  const [states, setStates] = useState<any>();
  const { Option } = Select;

  const { liff } = useLiff();

  const dropdownMenus = [
    {
      name: 'คำสั่งซื้อของฉัน',
      link: '/profile/my-order',
      onClick: () => {
        navigate('/profile/my-order');
      },
    },
    {
      name: 'ที่อยู่ของฉัน',
      link: '/profile/my-address',
      onClick: () => {
        navigate('/profile/my-address');
      },
    },
    {
      name: 'ข้อมูลบัญชีธนาคาร',
      link: '/profile/my-bank-account',
      onClick: () => {
        navigate('/profile/my-bank-account');
      },
    },
    {
      name: 'ข้อมูลของฉัน',
      link: '/profile/my-profile',
      onClick: () => {
        navigate('/profile/my-profile');
      },
    },
    {
      name: 'โปรไฟล์ช่าง',
      link: '/my-technician',
      onClick: () => {
        navigate('/my-technician');
      },
    },
    {
      name: 'ออกจากระบบ',
      link: '/logout',
      onClick: async () => {
        localStorage.removeItem('token');
        liff.logout();
        navigate('/login');
      },
    },
  ];

  const menus = [
    {
      name: 'หน้าแรก',
      link: '/home',
      onClick: () => {
        navigate('/');
      },
    },
    {
      name: 'ร้านค้าของฉัน',
      link: '/my-shops',
      onClick: () => {
        navigate('/my-shops');
      },
    },
    {
      name: 'หมวดหมู่สินค้า',
      link: '/product-categories',
      onClick: () => {
        navigate('/product-categories');
      },
    },
    {
      name: 'ร้านค้าใกล้ฉัน',
      link: '/shops/near-me',
      onClick: () => {
        navigate('/shops/near-me');
      },
    },
  ];

  const menusNonLogin = [
    {
      name: 'หน้าแรก',
      link: '/home',
      onClick: () => {
        navigate('/');
      },
    },
    {
      name: 'หมวดหมู่สินค้า',
      link: '/product-categories',
      onClick: () => {
        navigate('/product-categories');
      },
    },
    {
      name: 'ร้านค้าใกล้ฉัน',
      link: '/shops/near-me',
      onClick: () => {
        navigate('/shops/near-me');
      },
    },
  ];

  const renderMenus = (
    <Menu>
      {dropdownMenus.map((item: any, index: number) => (
        <Menu.Item key={index} className={styles.dropdownItem}>
          <a
            onClick={() => {
              if (item.onClick) item.onClick();
            }}
            className={styles.link}
          >
            {item.name}
          </a>
        </Menu.Item>
      ))}
    </Menu>
  );

  const onMenuClick = (item: any) => {
    if (item.onClick) {
      item.onClick();
    }
  };

  const checkUserLogin = (url: string) => {
    if (currentUser._id) {
      navigate(url);
    } else {
      navigate('/login');
    }
  };

  const updateUserInfo = async (value: any) => {
    try {
      const res = await axios.patch(`/users/${currentUser._id}`, value);
      const { status } = res;
      if (status === 200) {
        window.location.reload();
      }
    } catch (error) {
      message.error('เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง');
    }
  };

  const getState = async () => {
    setStates(await getStates());
    return;
  };

  useEffect(() => {
    if (!isEmpty(user)) {
      setCurrentUser(user);
      if (!user.currentState) {
        getState();
        setShowModelMissingData(true);
        setShowMaintainState(true);
      }

      if (!user.position) {
        setShowModelMissingData(true);
        setShowMaintainPosition(true);
      }
    }
  }, [user]);

  useEffect(() => {
    if (currentAddress?.results) {
      setCurrentAddresses(currentAddress?.results[0].formatted_address);
    }
  }, [currentAddress]);

  return (
    <>
      <div className={styles.navbarContainer}>
        <div className={styles.sectionLeft}>
          <div className={styles.logoWrapper}>
            <Logo width={48} height={48} path={logoPath} />
          </div>
          {currentUser.displayName ? (
            <div className={styles.hamburgerWrapper}>
              <DrawerMenu menus={menus} />
            </div>
          ) : (
            <div className={styles.hamburgerWrapper}>
              <DrawerMenu menus={menusNonLogin} />
            </div>
          )}
        </div>
        <div className={styles.middleContentWrapper}></div>
        {currentUser.displayName ? (
          <div className={styles.rightContentWrapper}>
            <div className={[styles.menuItem, styles.mainMenus].join(' ')}>
              <ul>
                {menus.map((item: any, index: number) => (
                  <li key={index}>
                    <a
                      onClick={() => {
                        onMenuClick(item);
                      }}
                    >
                      {item.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
            <div className={[styles.menuItem, styles.displayName].join(' ')}>
              <Dropdown
                overlay={renderMenus}
                trigger={['click']}
                className={styles.menuDropdown}
              >
                <a
                  className='ant-dropdown-link'
                  onClick={(e) => e.preventDefault()}
                >
                  <div className={styles.displayNameWrapper}>
                    ยินดีต้อนรับ!{' '}
                    {currentUser.displayName ? currentUser.displayName : ''}{' '}
                    <DownOutlined className={styles.arrow} />
                  </div>
                  <div className={styles.displayNameWrapperMobile}>
                    {currentUser.displayName ? currentUser.displayName : ''}{' '}
                    &nbsp;
                    {currentUser.photoURL ? (
                      <Avatar
                        icon={
                          <>
                            <img src={currentUser.photoURL} />
                          </>
                        }
                      />
                    ) : (
                      <Avatar icon={<UserOutlined />} />
                    )}
                  </div>
                </a>
              </Dropdown>
              <div className={styles.menuItemRight}>
                <Badge count={orderCount}>
                  <Link to={`/cart`}>
                    <Icon path={mdiCart} title='Cart' size={1} color='white' />
                  </Link>
                </Badge>
              </div>
            </div>
          </div>
        ) : (
          <div className={styles.rightContentWrapper}>
            <div className={[styles.menuItem, styles.mainMenus].join(' ')}>
              <ul>
                {menusNonLogin.map((item: any, index: number) => (
                  <li key={index}>
                    <a
                      onClick={() => {
                        onMenuClick(item);
                      }}
                    >
                      {item.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
            <a href='/login' style={{ color: 'white' }}>
              เข้าสู่ระบบ
            </a>
          </div>
        )}
      </div>

      <div className={styles.navbarDivider}></div>

      {isNoBannerPage ? (
        ''
      ) : (
        <>
          {showTechnicianBar ? (
            <>
              <SubNavbarSCGFamily />
              <div className={styles.serviceBanners}>
                <div style={{ flex: 'auto' }}>
                  <span onClick={() => checkUserLogin('/services')}>
                    <img
                      className={styles.banner}
                      src='/images/service-find-technician.png'
                    />
                  </span>
                </div>
                <div>
                  <span onClick={() => checkUserLogin('/apply-job')}>
                    <img
                      className={styles.banner}
                      src='/images/service-find-job.png'
                    />
                  </span>
                </div>
                <div>
                  <span onClick={() => checkUserLogin('/my-technician/orders')}>
                    <img
                      className={styles.banner}
                      src='/images/service-new-job.png'
                    />
                  </span>
                </div>
              </div>
            </>
          ) : (
            ''
          )}

          <Row>
            <Col span={24}>
              <div className={styles.rightContentWrapperAddress}>
                {currentAddresses && (
                  <Paragraph
                    ellipsis={{
                      rows: 1,
                      expandable: true,
                      symbol: 'ดูเพิ่ม',
                    }}
                    style={{
                      width: '100%',
                      display: 'flex',
                      justifyContent: 'flex-end',
                    }}
                  >
                    ที่อยู่ปัจจุบัน: {currentAddresses}
                  </Paragraph>
                )}
              </div>
            </Col>
          </Row>
        </>
      )}
      <Modal
        closable={false}
        open={showModelMissingData}
        width={400}
        footer={null}
      >
        <Form
          form={formUpdateUserInfo}
          onFinish={updateUserInfo}
          layout='vertical'
        >
          {showMaintainState && (
            <>
              <Row justify='center'>คุณสนใจซื้อวัสดุก่อสร้างที่จังหวัดไหน</Row>
              <Row justify='space-around' style={{ marginTop: '10px' }}>
                <Col style={{ width: '100%' }}>
                  <Form.Item
                    name={`currentState`}
                    rules={[
                      {
                        required: true,
                        message: 'กรุณากรอกข้อมูล!',
                      },
                    ]}
                  >
                    <Select
                      showSearch
                      filterOption={(input, option: any) =>
                        option.label.indexOf(input.toLowerCase()) >= 0
                      }
                      options={states}
                      placeholder='จังหวัด'
                    ></Select>
                  </Form.Item>
                </Col>
              </Row>
            </>
          )}
          {showMaintainPosition && (
            <>
              <Row justify='center'>ช่าง หรือ เจ้าของบ้าน</Row>
              <Row justify='space-around' style={{ marginTop: '10px' }}>
                <Col style={{ width: '100%' }}>
                  <Form.Item
                    name={`position`}
                    rules={[
                      {
                        required: true,
                        message: 'กรุณากรอกข้อมูล!',
                      },
                    ]}
                  >
                    <Select placeholder='ช่าง หรือ เจ้าของบ้าน'>
                      <Option value='technician'>ช่าง</Option>
                      <Option value='house-owner'>เจ้าของบ้าน</Option>
                    </Select>
                  </Form.Item>
                </Col>
              </Row>
            </>
          )}

          <Row>
            <Col style={{ width: '100%' }}>
              <Button
                type='primary'
                htmlType='submit'
                className={styles.button_submit}
              >
                ตกลง
              </Button>
            </Col>
          </Row>
        </Form>
      </Modal>
    </>
  );
};
export default TopNavbar;
